import { Navigate, useLocation } from 'react-router-dom';
import type { MembershipRole } from '@starter/shared';
import { useAuth } from '../auth/AuthContext.js';
import { homePathForAuthUser, isTenantUserWithRole } from '../auth/routing.js';

interface Props {
  roles?: MembershipRole[];
  children: React.ReactNode;
}

export function ProtectedRoute({ roles, children }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page-loading">
        <div className="spinner" aria-hidden />
        <p>Loading your session…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && !isTenantUserWithRole(user, roles)) {
    return <Navigate to={homePathForAuthUser(user)} replace />;
  }

  return children;
}
